<template>
  <DhPhoneBinding
    :username="username"
    :show="showBindingPhone"
    :validate="validateUsername"
    :key="bindKey"
  />
  <!--注册界面-->
  <Register :show="showRegister" :cancel="onCancelRegisterPopup" />
  <!--登录界面-->
  <Login :show="showLogin" :cancel="() => (showLogin = false)" />
  <!-- 选择国家 -->
  <SelectCountry :show="showSelectCountry" :from="from" />
  <!-- 重置密码 -->
  <van-popup
    class="popup_box"
    v-model:show="showResetPassword"
    round
    :style="{ padding: '64px' }"
    :closeOnClickOverlay="false"
    :transition-appear="true"
    transition="scaleIn"
  >
    <div @click="onHideResetPassword" class="popup_close close_center"><span></span></div>
    <div
      v-if="verifkStep > 1"
      style="float: left; color: #ffddac; margin-right: -0.7rem"
      @click="verifkStep--"
    >
      <i class="bi bi-arrow-left-short"></i>
    </div>
    <ResetPassword
      :title="$t('title.resetPassword')"
      :key="verifyKey"
      :verify="usernameSms"
      :api="onResetPassword"
      :changeStep="changeStep"
      :verifkStep="verifkStep"
      from="reset"
    />
  </van-popup>
  <!-- 修改密码 -->
  <ChangePassWord
    :show="showChangePassword"
    :key="changepasswordKey"
    :cancel="closeChangePassword"
  />
  <ActiveBoostList
    :show="showBoostListPopup"
    :cancel="() => (showBoostListPopup = false)"
    :boostList="boostList"
    :onShare="onShare"
    :onWitchDraw="onShare"
  />
  <first-deposit-popup
    :show="showFirstDepositPopup"
    :cancel="() => (showFirstDepositPopup = false)"
  />
  <first-popup :show="showFirstPopup" :cancel="() => (showFirstPopup = false)" />
</template>
<script>
import { getLocalStorage, Key, removeLocalStorage } from '@/common/localStorage'
import { validatePassword, validateUsername } from '@/common/valiadate'
import ChangePassWord from '@/components/ChangePassWord.vue'
import Login from '@/components/Login.vue'
import DhPhoneBinding from '@/components/PhoneBinding.vue'
import Register from '@/components/Register.vue'
import SelectCountry from '@/components/SelectCountry.vue'
import { BUS, POPUP } from '@/event/EventCenter'
import { getLocale } from '@/locales'
import { useEnvelopeStore } from '@/stores/envelope'
import { useLanguagesStore } from '@/stores/languages'
import { useLobbyStore } from '@/stores/lobby'
import { useUserStore } from '@/stores/user'
import { formatMoney, unitConversion } from '@/utils/helper'
import { mapActions, mapState } from 'pinia'
import ResetPassword from '@/components/ResetPassword.vue'
import { REPORT_EVENT, reportGtag } from '@/common/mgtag'
import ActiveBoostList from './active/ActiveBoostList.vue'
import FirstDepositPopup from '@/components/FirstDepositPopup.vue'
import FirstPopup from '@/components/FirstPopup.vue'

export default {
  data() {
    return {
      showBindingPhone: false,
      showRegister: false,
      showLogin: false,
      showSelectCountry: false,
      showResetPassword: false,
      showChangePassword: false,
      from: '',
      nextRouter: '',
      username: '',
      verifkStep: 1,
      changepasswordKey: 0,
      bindKey: 0,
      userBarKey: 0,
      verifyKey: 0,
      showBoostListPopup: false,
      boostList: [],
      showFirstDepositPopup: false,
      showFirstPopup: false
    }
  },
  components: {
    DhPhoneBinding,
    Register,
    Login,
    SelectCountry,
    ChangePassWord,
    ResetPassword,
    ActiveBoostList,
    FirstDepositPopup,
    FirstPopup
  },
  computed: {
    ...mapState(useUserStore, ['country', 'isLogin', 'balance']),
    ...mapState(useLanguagesStore, ['languages', 'currentPhone']),
    ...mapState(useLobbyStore, ['hasStickyBanner']),
    ...mapState(useEnvelopeStore, ['reward'])
  },
  mounted() {
    this.$bus.$on(BUS.SHOW_POPUP, ({ from, to, show }) => {
      console.log('From: =>>>', from)
      this.from = from
      switch (to) {
        case POPUP.LOGIN:
          this.showLogin = show
          this.showRegister = false
          if (from == 'login') {
            if (!show) {
              this.favorite(null, true).then(() => {
                this.updatecollectGameId(-1)
              })
              if (this.nextRouter == 'bonus') {
                this.nextRouter = ''
                this.$router.replace('/bonus')
              } else if (this.nextRouter == 'firstRecharge') {
                this.nextRouter = ''
                this.$router.replace('/firstRecharge')
              } else if (this.nextRouter == 'RushDepositView') {
                this.nextRouter = ''
                this.$router.replace('/rushdeposit')
              } else if (this.nextRouter == 'deposit_deeplink') {
                this.nextRouter = ''
                this.$bus.$emit(BUS.UPDATE_DEEPLINK, 'deposit')
              }
            }
            // this.$bus.$emit(BUS.REFRESH_PAGE)
            if (getLocalStorage(Key.clickEnvlopePopup) == 'true') {
              removeLocalStorage(Key.clickEnvlopePopup)
              if (this.isLogin) {
                this.envelope().then((res) => {
                  if (res.id > 0 && res.status < 3) {
                    window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web`
                  } else {
                    this.$bus.$emit(BUS.SHOW_ACTIVE_BOX, { hasOpened: false })
                  }
                })
              }
            }
            // else {
            //   location.reload()
            // }
          } else if (from == '401') {
            useUserStore()
              .logout()
              .then(() => {
                this.$bus.$emit(BUS.FULL_SCREEN, false)
                this.userBarKey++
                this.$router.replace('/')
              })
          } else if (from == 'bonus') {
            this.nextRouter = 'bonus'
          } else if (from == 'firstRecharge') {
            this.nextRouter = 'firstRecharge'
          } else if (from == 'RushDepositView') {
            this.nextRouter = 'RushDepositView'
          } else if (from == 'deposit') {
            this.nextRouter = 'deposit_deeplink'
          }
          if (this.showLogin && !['menu', 'register', 'bonus'].includes(from)) {
            // this.$t && showToast(this.$t('message.needLogin'))
          }
          break
        case POPUP.REGISTER:
          this.showRegister = show
          if (from == 'login') {
            this.showLogin = !show
          } else if (from == 'register') {
            if (!show) {
              if (getLocalStorage(Key.clickEnvlopePopup) == 'true') {
                removeLocalStorage(Key.clickEnvlopePopup)
                if (this.isLogin) {
                  this.envelope().then((res) => {
                    if (res.id > 0 && res.status < 3) {
                      window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web`
                    } else {
                      this.$bus.$emit(BUS.SHOW_ACTIVE_BOX, { hasOpened: false })
                    }
                  })
                }
              }
              // else {
              //   location.reload()
              // }
            }
          }
          break
        case POPUP.BINDING_PHONE:
          if (this.isLogin) {
            this.showBindingPhone = show
            if (!show) {
              this.bindKey++
            }
          } else {
            this.showLogin = true
            this.showBindingPhone = false
          }
          break
        case POPUP.SELECT_COUNTRY:
          this.showSelectCountry = show
          if (from == 'login') {
            this.showLogin = !show
          } else if (from == 'register') {
            this.showRegister = !show
          }
          break
        case POPUP.RESET_PASSWORD:
          this.showLogin = false
          this.showRegister = false
          this.showChangePassword = false
          this.onForget()
          break
        case POPUP.CHANGE_PASSWORD:
          this.showChangePassword = show
          if (!show) {
            this.onShowMenu()
          }
          break
        case POPUP.FIRST_DEPOSIT_POPUP:
          this.showFirstDepositPopup = show
          this.showLogin = show ? false : this.showLogin
          this.showRegister = show ? false : this.showRegister
          break
        case POPUP.PERKS_PLAY_POPUP:
          this.showFirstPopup = show
          this.showLogin = show ? false : this.showLogin
          this.showRegister = show ? false : this.showRegister
          break
        default:
          break
      }
    })
    //获取红包助力增长列表
    if (this.$router.currentRoute.value.path == '/') {
      if (!this.isLogin) {
        return
      }
      this.envelope().then((res) => {
        if (res.id > 0 && res.status < 3) {
          this.latestCollected(res.id).then((r) => {
            this.boostList = r.records || []
            if (this.boostList.length == 0) {
              this.showBoostListPopup = false
            } else {
              const addList = this.boostList.filter(
                (item) => item.collectType > 1 && item.currency != 'VPS' && item.currency != 'BONUS'
              )
              this.showBoostListPopup = addList.length > 0
            }
          })
        }
      })
    }
  },
  methods: {
    formatMoney,
    validatePassword,
    validateUsername,
    unitConversion,
    ...mapActions(useUserStore, {
      usernameSms: 'usernameSms',
      restPwd: 'restPwd',
      checkBindViaUser: 'checkBindViaUser',
      logout: 'logout'
    }),
    ...mapActions(useLobbyStore, {
      favorite: 'favorite',
      updatecollectGameId: 'updatecollectGameId',
      popup: 'popup',
      hidePopup: 'hidePopup',
      getBannersHomeTop: 'getBannersHomeTop',
      enterGame: 'enterGame',
      hideStickyBanners: 'hideStickyBanners'
    }),
    ...mapActions(useEnvelopeStore, { envelope: 'envelope', latestCollected: 'latestCollected' }),
    onShare() {
      window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web&from=share`
    },
    onForget() {
      console.log('onForget')
      this.verifyKey++
      this.showResetPassword = true
      this.showLogin = false
      this.username = ''
      this.password = ''
    },
    onCancelRegisterPopup() {
      this.showRegister = false
      reportGtag(REPORT_EVENT.REGISTER.R1_CLOSE, 'click')
    },
    onHideResetPassword() {
      this.showResetPassword = false
      if (!this.isLogin) {
        this.showLogin = true
      } else if (this.from != 'deeplink') {
        this.$bus.$emit(BUS.SHOW_POPUP, {
          from: 'changepassword',
          to: POPUP.CHANGE_PASSWORD,
          show: true
        })
      }
      this.username = ''
      this.password = ''
      this.verifyKey++
    },
    changeStep(step) {
      this.verifkStep = step
      console.log('asdfasdf', this.verifkStep)
    },
    closeChangePassword() {
      this.changepasswordKey++
      this.showChangePassword = false
      if (this.from != 'deeplink') {
        this.onShowMenu()
      }
    },
    onResetPassword(country, password, username, code) {
      return this.restPwd(country, password, username, code).then((response) => {
        if (response) {
          this.onHideResetPassword()
        }
      })
    },
    onShowMenu() {
      this.$bus.$emit(BUS.SHOW_MENU, true)
    }
  }
}
</script>
<style lang="scss" scoped>
.close_center {
  display: flex !important;
  margin-top: -0.5rem !important;
  justify-content: center;
  align-items: flex-start;
}

.popup_close {
  height: 0.8rem;
  width: 0.8rem;
  border-radius: 50%;
  background-color: #000;
  border: solid 4px transparent;
  background-image: linear-gradient(#000, #000),
    linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  margin-top: -1.2rem;
  text-align: center;
  position: absolute;
  display: block;
  z-index: 2;
  margin-left: 90%;

  span {
    display: inline-block;
    width: 0.6rem;
    height: 0.08rem;
    background-color: #aa884a;
    background-image: linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    transform: rotate(45deg);
    margin-top: 0.355rem;
  }

  span::after {
    content: '';
    display: block;
    width: 0.6rem;
    height: 0.08rem;
    background-color: #aa884a;
    background-image: linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    transform: rotate(-90deg);
  }
}

.popup_box {
  width: 6.5rem;
  height: auto;
  margin: 0 auto;
  padding: 0 !important;
  overflow: visible !important;
  border: solid 0.04rem transparent;
  border-radius: 0.16rem;
  background-color: #000;
  background-image: linear-gradient(#000, #000),
    linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  text-align: center;
  // overflow: hidden;

  .popup {
    width: 90%;
    height: auto;
    border-radius: 12px;
    display: block;
    padding: 5% 5% 5% 5%;
    margin: 0 auto;

    h1 {
      font-size: 0.3rem;
      line-height: 0.4rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }

    h2 {
      font-size: 0.24rem;
      line-height: 0.3rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }

    p {
      line-height: 0.32rem;
      margin: 0;
      color: #fff;
    }

    .popup_nation {
      width: 100%;
      overflow: hidden;

      li {
        float: left;
        width: 93.4%;
        border-radius: 0.16rem;
        display: inline-block;
        line-height: 0.5rem;
        border: 2px solid #aa884a;
        padding: 3%;
        margin: 0.15rem 0;

        P {
          float: left;
          color: #aa884a;
          font-size: 0.24rem;
          margin-left: 0.2rem;
          line-height: 0.75rem;
          display: inline-block;
        }

        img {
          border-radius: 0.16rem;
          float: left;
          width: 25%;
        }

        i {
          float: right;
          font-size: 0.75rem;
          color: #ffddac;
          display: none;
        }
      }
    }

    .popup_nation_active {
      border: 2px solid #ffddac !important;
      box-shadow:
        inset 0 0 0.2rem #ffddac,
        inset 0 0 0.1rem #ffddac,
        inset 0 0 0.05rem #ffddac;

      p {
        color: #ffddac !important;
      }

      i {
        color: #ffddac !important;
        display: block !important;
      }
    }

    .steps {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0.8rem 0;

      .step {
        flex-basis: 50%;
      }

      .step-head {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }

      .step:last-of-type .step-head .line {
        display: none;
      }

      .active-icon {
        color: #fff !important;
        background-color: #aa884a !important;
      }

      .icon {
        font-size: 0.3rem;
        line-height: 0.6rem;
        font-weight: bold;
        color: #95a5a5;
        text-align: center;
        position: absolute;
        width: 0.6rem;
        height: 0.6rem;
        background-color: #324559;
        border-radius: 50%;
        z-index: 1;
      }

      .line {
        position: absolute;
        right: -50%;
        left: 50%;
        width: 100%;
        height: 0.1rem;
        background-color: #aa884a;
        z-index: 0;
      }

      .active-line {
        background-color: #324559 !important;
      }
    }

    .code_digit {
      margin: 0.2rem 0;
      padding: 0;
      width: 100%;
      overflow: hidden;

      li {
        line-height: 0.7rem;
        background-color: #ffddac;
        display: inline-block;
        border-radius: 0.16rem;
        float: left;
        width: 14%;
        height: 0.7rem;
        margin: 0 1.33%;
        padding: 0;
        text-align: center;
        color: black;
        font-size: 0.48rem;
      }

      input {
        outline-style: none;
        outline-width: 0;
        border: none;
        border-style: none;
        text-shadow: none;
        -webkit-appearance: none;
        -webkit-user-select: text;
        outline-color: transparent;
        background-color: transparent;
        box-shadow: none;
        font-size: 0.48rem;
        line-height: 0.7rem;
        float: left;
        width: 94.5%;
        margin: -0.7rem 0 0 5.5%;
        padding: 0;
        position: relative;
        z-index: 2;
        letter-spacing: 0.71rem;
        overflow: hidden;
        overflow-x: hidden;
        text-align: left;
        color: rgba($color: #000000, $alpha: 0);
      }
    }

    .btn_100 {
      line-height: 0.66rem;
      text-align: center;
      border-radius: 0.33rem;
      margin: 0.4rem 0;
      font-size: 0.4rem;
    }

    .btn_yellow {
      color: #fff;
      background-color: #aa884a;
      border: 2px solid #aa884a;
    }

    .popup_footer {
      text-align: center;
      margin: 0px;
      padding: 0.3rem 0;
      height: auto;
      width: 100%;
      color: #ffddac;
      font-size: 0.38rem;

      overflow: hidden;
      text-decoration: underline;
    }
  }
}
</style>
